// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"33524":"app","99254":"component---src-pages-why-yelowsoft-js"}[chunkId] || chunkId) + "." + {"4120":"10ce2bdb4c854c95a31d","33524":"c7bc460fe94fb87e98ef","99254":"be404af29e92e6fc228e"}[chunkId] + ".css";
};